
import { stringToDOM } from "../../src/globals";
import { isTouchDevice } from "../../src/compat";
import { Navigation } from "../../src/tools/Navigation";

const av = Autodesk.Viewing;

const html = [
'<div class="orbit-gizmo noselect">',
'<div class="outside"></div>',
'<div class="ring"></div>',
'<div class="layout-hor">',
'<div class="edgemark-area"><div class="edgemark"></div></div>',
'</div>',
'<div class="layout-mid">',
'<div class="layout-ver">',
'<div class="edgemark-area"><div class="edgemark"></div></div>',
'</div>',
'<div class="circle">',
'<div class="crosshair-area">',
'<div class="crosshair-v"></div>',
'<div class="crosshair-h"></div>',
'</div>',
'</div>',
'<div class="layout-ver">',
'<div class="edgemark-area"><div class="edgemark"></div></div>',
'</div>',
'</div>',
'<div class="layout-hor">',
'<div class="edgemark-area"><div class="edgemark"></div></div>',
'</div>',
'</div>'].
join("\n");

export class FusionOrbitTool extends av.GlobalManagerProvider {
  constructor() {
    super();
    this._names = ["fusion orbit", "fusion orbit constrained"];

    this._PERCENT_SIZE = 0.8;
    this._EXIT_PERCENT_SIZE = 1.2;
    this._CIRCLE_CURSOR_STYLE = "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAt1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD///8AAAAzMzP6+vri4uISEhKKioqtra2dnZ2EhIR9fX10dHRkZGQdHR3t7e3Hx8e5ubm1tbWoqKhWVlZKSko4ODgICAjv7+/o6OjMzMyxsbFOTk4pKSkXFxcEBAT29vbW1tZ6enpISEgLCwvhzeX+AAAAGXRSTlMANRO0nHRJHfnskIxQRKh89syDVwTWZjEJxPFEswAAAOFJREFUKM+1j+lygkAQhIflEAJe0Rw9u4CCeKKoSTTX+z9XoMJWWeX+ssrvZ3f19DQ5zOw/0DUMQPlmQ72bE2adBp8/Rp3CQUi3ILx+bxj4fjDs9T1Bmo6bbPPN8aDU4bjJt4nb+de789kSFyxn826jW3ICLNZZKU8nWWbrBTCRVm04U8TpjquRFf1Go0d7l8aYOrUR7FGEFr1S9LGymwthgX2gE/Kl0cHPOtF2xOWZ5QpIC93RflW4InkDoPRXesd5LJIMQPzV7tCMa7f6BvhJL79AVDmYTNQ1NhnxbI/uwB8H5Bjd4zQPBAAAAABJRU5ErkJggg==), auto";

    this._orbitModes = {
      HORIZONTAL: 0,
      VERTICAL: 1,
      ROLL: 2
    };

    this._orbitSpeeds = {
      HORIZONTAL: 0.005,
      VERTICAL: 0.005,
      ROLL: 1.0
    };

    this._gizmoElem = undefined;
    this._gizmoRect = {};
    this._ringElem = undefined;
    this._outsideElem = undefined;
    this._isConstrained = undefined;
    this._camera = undefined;
    this._isTouch = isTouchDevice();
    this._isClickToExit = false;

    this._mouse = {
      buttons: [],
      src: undefined,
      x: 0,
      y: 0,
      dx: 0,
      dy: 0,
      firstMove: true, // for dx/dy calc
      mode: undefined
    };

    // PRIVATE FUNCTIONS

    this._onMouseDown = (e) => {
      this._mouse.buttons[e.touches ? 0 : e.button] = true;
      this._mouse.src = e.target.className;
      this._mouse.x = 0;
      this._mouse.y = 0;
      this._mouse.dx = 0;
      this._mouse.dy = 0;
      this._mouse.firstMove = true;
      this._mouse.mode = undefined;

      if (this._mouse.src === "ring") {
        this._mouse.mode = this._orbitModes.ROLL;
      } else
      if (this._mouse.src === "edgemark-area") {
        if (e.target.parentNode.className === "layout-ver")
        this._mouse.mode = this._orbitModes.HORIZONTAL;else
        if (e.target.parentNode.className === "layout-hor")
        this._mouse.mode = this._orbitModes.VERTICAL;
      }

      this._centerPivot();

      e.stopPropagation();
    };

    this._onMouseUp = (e) => {
      this._mouse.buttons[e.touches ? 0 : e.button] = false;
      this._mouse.src = undefined;
    };

    this._onMouseMove = (e) => {
      if (!this._mouse.buttons[0]) return;

      this._updateMousePos(e);
      this._updateCamera();

      this._mouse.firstMove = false;
    };

    this._updateMousePos = (e) => {
      var pageX = e.touches ? e.touches[0].pageX : e.pageX;
      var pageY = e.touches ? e.touches[0].pageY : e.pageY;

      if (!this._mouse.firstMove) {
        this._mouse.dx = pageX - this._mouse.x;
        this._mouse.dy = pageY - this._mouse.y;
      }
      this._mouse.x = pageX;
      this._mouse.y = pageY;
    };

    this._updateCamera = () => {

      // if (_mouse.dx === 0 && _mouse.dy === 0) return;
      switch (this._mouse.mode) {
        case this._orbitModes.ROLL:
          if (!this.navapi.isActionEnabled('roll')) {
            return;
          }
          break;
        case this._orbitModes.HORIZONTAL:
        case this._orbitModes.VERTICAL:
          if (!this.navapi.isActionEnabled('orbit')) {
            return;
          }
          break;
      }

      var eyeVec = this._camera.target.clone().sub(this._camera.position).normalize();
      var rightVec = eyeVec.clone().cross(this._camera.up).normalize();
      var upVec = rightVec.clone().cross(eyeVec).normalize();
      this._camera.up.copy(upVec); // update camera.up

      if (this._mouse.mode === this._orbitModes.ROLL) {
        var start = new THREE.Vector3(this._mouse.x - this._gizmoRect.center.x, this._mouse.y - this._gizmoRect.center.y, 0);
        var end = new THREE.Vector3(this._mouse.dx, this._mouse.dy, 0).add(start);
        start.normalize();
        end.normalize();
        var cross = start.clone().cross(end);
        var angle = Math.asin(cross.z);
        this._camera.up.applyAxisAngle(eyeVec, -angle * this._orbitSpeeds.ROLL);
      } else
      {
        var rotAxis, rotAmount;

        if (this._mouse.mode === this._orbitModes.HORIZONTAL) {
          rotAmount = -this._mouse.dx * this._orbitSpeeds.HORIZONTAL;
          if (this._isConstrained)
          this._camera.up = Navigation.snapToAxis(this._camera.up.clone()); // snap up vec
          rotAxis = this._camera.up;
        } else
        if (this._mouse.mode === this._orbitModes.VERTICAL) {
          rotAmount = -this._mouse.dy * this._orbitSpeeds.VERTICAL;
          if (this._isConstrained) {
            if (this._mouse.firstMove) // first time move, snap
              this._camera.up = Navigation.snapToAxis(this._camera.up.clone());
            rotAxis = eyeVec.clone().cross(this._camera.up).normalize(); // new right vec
          } else
          {
            rotAxis = rightVec;
          }
          this._camera.up.applyAxisAngle(rotAxis, rotAmount);
        }

        var pivot = this.navapi.getPivotPoint();
        var newPivotToCam = this._camera.position.clone().sub(pivot);
        newPivotToCam.applyAxisAngle(rotAxis, rotAmount);
        this._camera.position.addVectors(pivot, newPivotToCam); // orbit position

        var newPivotToTarget = this._camera.target.clone().sub(pivot);
        newPivotToTarget.applyAxisAngle(rotAxis, rotAmount);
        this._camera.target.addVectors(pivot, newPivotToTarget); // orbit target
      }

      this._camera.dirty = true;

    };

    // may return camera.target, do not modify
    this._findTarget = () => {
      var eyeVec = this._camera.target.clone().sub(this._camera.position).normalize();
      var hit = this.viewer.impl.rayIntersect(new THREE.Ray(this._camera.position, eyeVec));
      return hit && hit.intersectPoint ?
      hit.intersectPoint :
      this._camera.target;
    };

    this._getCameraPlane = (pos, nor) => {
      var planeNor = nor || pos.clone().sub(this._camera.position).normalize();
      return new THREE.Plane(
        planeNor, -planeNor.x * pos.x - planeNor.y * pos.y - planeNor.z * pos.z
      );
    };

    this._centerPivot = () => {
      // find distance pivot to camera plane
      // set new pivot to be that distance along eye vector
      var eyeVec = this._camera.target.clone().sub(this._camera.position).normalize();
      var plane = this._getCameraPlane(this._camera.position, eyeVec);
      var dist = plane.distanceToPoint(this._camera.pivot);
      this._camera.pivot.copy(eyeVec).multiplyScalar(dist).add(this._camera.position);
    };

    this._onMouseDownCircle = (e) => {
      if (!e.touches && e.button === 0)
      this._centerPivot(); // center pivot before passing thru to orbit tool
    };

    this._clickToExit = () => {
      if (this._isClickToExit)
      this.viewer.setActiveNavigationTool();
    };

    this._clickToFocus = (x, y) => {
      var hit = this.viewer.impl.hitTest(x, y);
      var newTarget;

      if (hit && hit.intersectPoint) {
        newTarget = hit.intersectPoint;
      } else
      {
        // intersect camera plane
        var ray = this.viewer.impl.viewportToRay(this.viewer.impl.clientToViewport(x, y));
        newTarget = new THREE.Vector3();
        ray.intersectPlane(this._getCameraPlane(this._camera.target), newTarget);
      }

      var newCamPos = this._camera.position.clone().sub(this._findTarget()).add(newTarget);
      this.navapi.setRequestTransition(true, newCamPos, newTarget, this._camera.fov);
    };
  }
  setViewer(viewer) {
    this.viewer = viewer;
    this.navapi = viewer ? viewer.navigation : null;
    viewer && this.setGlobalManager(viewer.globalManager);
  }

  // TOOL INTERFACE
  register() {
    this._gizmoElem = stringToDOM(html);
    this._gizmoElem.style.display = "none";
    this.viewer.canvasWrap.insertBefore(this._gizmoElem, this.viewer.canvasWrap.firstChild);

    this._ringElem = this._gizmoElem.querySelector(".ring");
    this._ringElem.addEventListener("mousedown", this._onMouseDown);

    Array.prototype.forEach.call(this._gizmoElem.querySelectorAll(".edgemark-area"), (elem) => {
      elem.addEventListener("mousedown", this._onMouseDown);
      if (this._isTouch) elem.addEventListener("touchstart", this._onMouseDown);
    });

    this.addWindowEventListener("mouseup", this._onMouseUp);
    this.addWindowEventListener("mousemove", this._onMouseMove);

    // click to exit
    this._outsideElem = this._gizmoElem.querySelector(".outside");
    this._outsideElem.addEventListener("mousedown", this._clickToExit);

    // before passing thru to orbit (default) tool
    var circleElem = this._gizmoElem.querySelector(".circle");
    circleElem.addEventListener("mousedown", this._onMouseDownCircle);

    if (this._isTouch) {
      this._ringElem.addEventListener("touchstart", this._onMouseDown);
      this.addWindowEventListener("touchend", this._onMouseUp);
      this.addWindowEventListener("touchmove", this._onMouseMove);
      this._outsideElem.addEventListener("touchstart", this._clickToExit);
      circleElem.addEventListener("touchstart", this._onMouseDownCircle);
    }

    this._camera = this.viewer.impl.camera;
  }

  deregister() {
    this.removeWindowEventListener("mouseup", this._onMouseUp);
    this.removeWindowEventListener("mousemove", this._onMouseMove);
    this._outsideElem.removeEventListener("mousedown", this._clickToExit);

    if (this._isTouch) {
      this.removeWindowEventListener("touchend", this._onMouseUp);
      this.removeWindowEventListener("touchmove", this._onMouseMove);
      this._outsideElem.removeEventListener("touchstart", this._clickToExit);
    }

    this.viewer.canvasWrap.removeChild(this._gizmoElem);

    this._gizmoElem = undefined;
    this._ringElem = undefined;
    this._outsideElem = undefined;
  }

  activate(name) {
    this._gizmoElem.style.display = "";

    this.handleResize();

    this._isConstrained = name === "fusion orbit constrained";

    var hyperlink = this.viewer.toolController.isToolActivated("hyperlink");

    // Need to make Hyperlink sit on top of default navigation tool
    if (hyperlink)
    this.viewer.toolController.deactivateTool("hyperlink");

    if (this._isConstrained) {
      this.viewer.setDefaultNavigationTool("orbit");
      this.viewer.prefs.set("fusionOrbitConstrained", true);
    } else
    {
      this.viewer.setDefaultNavigationTool("freeorbit");
      this.viewer.prefs.set("fusionOrbitConstrained", false);
    }

    if (hyperlink)
    this.viewer.toolController.activateTool("hyperlink");

    this.viewer.navigation.setZoomTowardsPivot(true);
  }

  deactivate() {
    this._gizmoElem.style.display = "none";
    this.viewer.navigation.setZoomTowardsPivot(this.viewer.prefs.get('zoomTowardsPivot'));
  }

  getNames() {
    return this._names;
  }

  getName() {
    return this._names[0];
  }

  update() {
    return false;
  }

  handleSingleClick(event) {
    this._clickToFocus(event.canvasX, event.canvasY);
    return true;
  }

  handleDoubleClick() {
    return true; // disabled, does not play nice with SingleClick
  }

  handleSingleTap(event) {
    this._clickToFocus(event.canvasX, event.canvasY);
    return true;
  }

  handleDoubleTap() {
    return false; // enabled, DoubleTap doesn't register the first SingleTap
  }

  handleKeyDown() {
    return false;
  }

  handleKeyUp() {
    return false;
  }

  handleWheelInput() {
    return false;
  }

  handleButtonDown() {
    return false;
  }

  handleButtonUp() {
    return false;
  }

  handleMouseMove(event) {
    var rect = this.viewer.impl.getCanvasBoundingClientRect();
    var vp;
    if (rect.width > rect.height) {
      vp = new THREE.Vector2(
        ((event.canvasX + 0.5) / rect.width * 2 - 1) * rect.width / rect.height,
        -((event.canvasY + 0.5) / rect.height) * 2 + 1
      );
    } else {
      vp = new THREE.Vector2(
        (event.canvasX + 0.5) / rect.width * 2 - 1,
        (-((event.canvasY + 0.5) / rect.height) * 2 + 1) * rect.height / rect.width
      );
    }

    var radius = vp.length();

    var isOutside = radius > this._EXIT_PERCENT_SIZE;
    if (this._isClickToExit !== isOutside) {
      if (isOutside)
      this._outsideElem.style.cursor = "";else

      this._outsideElem.style.cursor = this._CIRCLE_CURSOR_STYLE;
      this._isClickToExit = isOutside;
      // console.log("click exit: " + _isClickToExit);
    }

    return false;
  }

  handleGesture() {
    this._centerPivot();
    return false;
  }

  handleBlur() {
    return false;
  }

  handleResize() {
    // for mouse roll
    var rect = this._gizmoElem.getBoundingClientRect();
    const _window = this.getWindow();
    this._gizmoRect.left = rect.left + _window.pageXOffset;
    this._gizmoRect.top = rect.top + _window.pageYOffset;
    this._gizmoRect.width = rect.width;
    this._gizmoRect.height = rect.height;
    this._gizmoRect.center = {};
    this._gizmoRect.center.x = this._gizmoRect.left + this._gizmoRect.width / 2;
    this._gizmoRect.center.y = this._gizmoRect.top + this._gizmoRect.height / 2;

    // resize gizmo
    var dim = (_window.innerWidth > _window.innerHeight ? _window.innerHeight : _window.innerWidth) * this._PERCENT_SIZE;
    this._gizmoElem.style.width = this._gizmoElem.style.height = "" + dim + "px";
    this._gizmoElem.style.top = this._gizmoElem.style.left = "calc(50% - " + dim / 2 + "px)";
    this._ringElem.style.borderWidth = "" + dim * 0.1 + "px";
  }

}